module.exports = __webpack_public_path__ + "static/media/roboto-v20-latin-300.ef7c6637.woff2";